var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 381.59 485.92998",
    width: 381.59,
    height: 485.92999,
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "translate(-769.21,-244.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 911.08,301.71 c 11.42,24.29 24.89,51.19 34.04,63.83 13.72,18.96 49.7,53.44 72.56,74.67 -20.46,19.42 -51.06,49.38 -63.03,65.93 -10.65,14.72 -27.82,46.51 -41.83,73.61 -12.48,-26.32 -27.89,-56.72 -38.87,-71.35 -12.11,-16.14 -46.17,-45.64 -68.83,-64.55 22.16,-22.28 56.79,-58.02 70.08,-76.77 9.39,-13.24 23.72,-40.77 35.89,-65.37 m 0.63,-57.13 c 0,0 -38.91,84.22 -56.17,108.57 -18.36,25.9 -86.34,92.41 -86.34,92.41 0,0 69.07,55.44 85.47,77.3 19.22,25.62 57.03,112.62 57.03,112.62 0,0 43.8,-89.45 62.45,-115.22 16.71,-23.09 78.99,-80.23 78.99,-80.23 0,0 -69.86,-62.83 -88.52,-88.61 C 947.93,328.34 911.7,244.58 911.7,244.58 v 0 z",
    id: "path1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m 1072.14,730.49 -10.39,-23.92 c -6,-13.79 -17.49,-38.32 -22.82,-45.41 -4.17,-5.56 -22.52,-21.28 -34.21,-30.67 l -10.59,-8.5 9.7,-9.5 c 7.82,-7.65 29.4,-29.33 35.28,-37.62 5.48,-7.73 18.28,-34.53 22.75,-44.2 l 11.3,-24.45 10.69,24.72 c 5.75,13.29 16.59,36.75 21.19,43.11 5.88,8.12 27.91,28.56 35.9,35.75 l 9.86,8.87 -9.77,8.97 c -9.88,9.07 -27.3,25.85 -31.94,32.27 -6,8.29 -20.42,36.87 -25.47,47.18 l -11.47,23.42 z m -41.95,-110.25 c 9.73,8.16 22.98,19.77 28.01,26.46 4.29,5.71 10.1,16.92 15.13,27.34 5.63,-10.78 12.08,-22.53 16.24,-28.28 4.89,-6.76 16.92,-18.64 25.6,-26.93 -9.77,-9.12 -24.02,-22.89 -29.65,-30.67 -3.53,-4.88 -8.52,-14.61 -13.03,-24.04 -4.8,9.59 -10.11,19.57 -13.73,24.68 -5.44,7.67 -19.11,21.88 -28.57,31.43 z",
    id: "path2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/sparkle.c8e1c5d67968018e7b8c128cd872ac54.svg";
export { ForwardRef as ReactComponent };